import { render, staticRenderFns } from "./EditWorkDetailPage.vue?vue&type=template&id=08c44941&"
import script from "./EditWorkDetailPage.vue?vue&type=script&lang=js&"
export * from "./EditWorkDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports